import React from 'react';
import classNames from 'classnames';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faClipboard,
  faTimes,
  faChevronDown,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faTrashAlt,
  faTimes as faTimesRegular,
  faEye,
  faEyeSlash,
  faEllipsisH,
  faCopy,
  faPlus,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './IconButton.scss';

declare type IconButtonIcon =
  | 'chevronDown'
  | 'copy'
  | 'altCopy'
  | 'eye'
  | 'eyeSlash'
  | 'remove'
  | 'times'
  | 'trash'
  | 'select'
  | 'plus';

declare type IconButtonProps = {
  icon: IconButtonIcon;
  hiddenLabel: string;
  className?: string;
  onClick: () => void;
  // Vince: I don't like having this prop here, it was added to allow TS
  // compatibility to use this component as a custom toggle component for
  // Bootstrap.Dropdown component which requires this key to be on the element
  bsRole?: 'toggle' | 'menu';
};

const IconButtonIconProp: {
  [key in IconButtonIcon]: IconProp;
} = {
  chevronDown: faChevronDown,
  copy: faClipboard,
  altCopy: faCopy,
  eye: faEye,
  eyeSlash: faEyeSlash,
  remove: faTimes,
  times: faTimesRegular,
  trash: faTrashAlt,
  select: faEllipsisH,
  plus: faPlus,
};

export const IconButton = React.memo(
  ({ icon, hiddenLabel, className, onClick }: IconButtonProps) => {
    const iconProp = IconButtonIconProp[icon];
    return (
      <button
        title={hiddenLabel}
        type="button"
        className={classNames('react-icon-button', className)}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={iconProp} fixedWidth />
        <span className="hidden-text"> {hiddenLabel}</span>
      </button>
    );
  }
);
